import React from "react";
import styled from "styled-components";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Button from "react-bootstrap/Button";
import "../../Styles/styles.scss"
import AccountPopup from "../../views/AccountPopup";



const InitialsCircleStyle = {
  backgroundColor: "var(--white)",
 display:'flex',
 justifyContent:'center',
 alignItems:'center',
  fontWeight: "var(--boldFont)",
  fontFamily: "$font",
  border: "1px solid orange",
  width: "45px",
  height: "45px",
  borderRadius: "100%",
  color: "var(--orange)",
  boxShadow: "none",
};



const popover = (
  <Popover className="PopStyle" id="popover-basic">
    <AccountPopup/>
  </Popover>
);

const MyPopover = () => {
  return (
   <>
    <PopoverContainer>
      <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={popover}>
        <Button style={InitialsCircleStyle}>LM</Button>
      </OverlayTrigger>
    </PopoverContainer>
    </>
  )
}
export default MyPopover;

const PopoverContainer =styled.div`
  display: flex;
  padding: 0 40px;
  justify-content: end;
  align-items: center;
`